export default "__VITE_ASSET__YDeQzbE5__"